import styled, { type CSSObject } from '@emotion/styled';
import type { ThemeProps } from '@emotion/react';
import { themeFont } from '../../../lib/themeFont';

const textShadow = 'text-shadow: 0 0 50px hsla(0,0%,0%,1);';

interface SiteSubtitleProps {
  heroVersion?: boolean;
}

const SiteSubtitle = styled('div')`
  line-height: 1;
  margin: 8px 0;

  ${(props: SiteSubtitleProps) =>
    props.heroVersion ? `${textShadow} color: white;` : ''}

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.SiteSubtitle}

  ${themeFont('s5')}
`;

const DateLocationWrapper = styled('div')`
  text-align: center;
`;

interface SiteSubtitleWithDateLocationProps extends SiteSubtitleProps {
  ['data-testid']?: string | undefined;
  weddingDate?: string | null | undefined;
  weddingLocation?: string | null | undefined;
  countdownDays?: number | null | undefined;
}

export const SiteSubtitleWithDateLocation = ({
  weddingDate,
  weddingLocation,
  countdownDays,
  heroVersion = false,
  ...rest
}: SiteSubtitleWithDateLocationProps) => {
  const dateLocation = [weddingDate, weddingLocation]
    .filter((v?: string | undefined | null): boolean => !!v && v !== '')
    .join(' • ');

  return (
    dateLocation && (
      <DateLocationWrapper>
        <SiteSubtitle heroVersion={heroVersion} {...rest}>
          {dateLocation}
        </SiteSubtitle>
        {countdownDays != null && (
          <SiteSubtitle
            data-testid="header-countdown"
            heroVersion={heroVersion}
          >
            {`${countdownDays} ${countdownDays === 1 ? 'Day' : 'Days'} To Go!`}
          </SiteSubtitle>
        )}
      </DateLocationWrapper>
    )
  );
};

export default SiteSubtitle;
